import CardWithTitle from "features/affiliation/common/CardWithTitle";
import { AffiliationTabs } from "features/affiliation/common/types";
import useReferredUsers from "features/affiliation/common/hooks/useReferredUsers";
import ReferralEmptyState from "features/affiliation/common/ReferralEmptyState";
import ChartCardLayout from "common/Layouts/ChartCardLayout";
import BarChart from "common/Charts/BarChart";
import { BASE_CHART_TIME_RANGES } from "@shared/common/constants";
import { useMemo } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface ReferredUsersLineChartProps {
  hideSeeAllButton?: boolean;
  inOverview?: boolean;
}

const ReferredUsersBarChart = ({
  hideSeeAllButton,
  inOverview,
}: ReferredUsersLineChartProps) => {
  const {
    users,
    referredChartQuery,
    formattedBarChartData,
    timeRange,
    setTimeRange,
  } = useReferredUsers(AffiliationTabs.REFERRED_USERS);
  const showEmptyState = !users?.length;
  const loading = referredChartQuery.isFetching;
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  const barChart = useMemo(
    () => (
      <BarChart data={formattedBarChartData} loading={loading} precision={2} />
    ),
    [formattedBarChartData, loading]
  );

  return (
    <CardWithTitle
      title={t("overview.new_referred_users")}
      relatedTab={hideSeeAllButton ? undefined : AffiliationTabs.REFERRED_USERS}
      cardStyle={{ maxHeight: inOverview ? "100%" : 425 }}
    >
      <div style={{ height: "90%", marginTop: 12 }}>
        {showEmptyState ? (
          <ReferralEmptyState tab={AffiliationTabs.REFERRED_USERS} />
        ) : (
          <ChartCardLayout
            chart={barChart}
            timeRanges={BASE_CHART_TIME_RANGES}
            selectedTimeRange={timeRange}
            setTimeRange={setTimeRange}
          />
        )}
      </div>
    </CardWithTitle>
  );
};

export default ReferredUsersBarChart;
